import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    setDoc,
    where,
    orderBy,
    limit
} from "firebase/firestore";
import {fireStoreDB} from "../../firebase/client-app";
import {Promise} from "bluebird";
import _ from "lodash";
import {DATA_LIMIT} from "../constants/printful.constant";

export {
    addPrintfulSyncProducts,
    addSinglePrintfulSyncProducts,
    updateSinglePrintfulSyncProducts,
    getSinglePrintfulSyncProducts,
    getAllPrintfulSyncProducts,
    searchPrintfulSyncProducts,
    searchPrintfulSyncProductsWithSearchCriteria,
    preparePrintfulSyncProductsList
}

const collectionName = 'printful-sync-products';
const collectionReference = collection(fireStoreDB, collectionName);

const addPrintfulSyncProducts = (printfulSyncProducts) => {
    return Promise.map(printfulSyncProducts, async printfulSyncProducts => {
        await addSinglePrintfulSyncProducts(printfulSyncProducts);
    });
}

const addSinglePrintfulSyncProducts = (printfulSyncProducts) => {
    printfulSyncProducts.createdAt = new Date();
    printfulSyncProducts.updatedAt = printfulSyncProducts.createdAt;
    return addDoc(collectionReference, printfulSyncProducts);
}

const updateSinglePrintfulSyncProducts = (printfulSyncProducts) => {
    const documentReference = doc(fireStoreDB, collectionName, printfulSyncProducts.id);
    printfulSyncProducts.updatedAt = new Date();
    return setDoc(documentReference, printfulSyncProducts);
}

const getSinglePrintfulSyncProducts = async (printfulSyncProductsId) => {
    const documentReference = doc(fireStoreDB, collectionName, printfulSyncProductsId);
    const printfulSyncProductsDoc = await getDoc(documentReference);
    return prepareSinglePrintfulSyncProducts(printfulSyncProductsDoc);
}

const getAllPrintfulSyncProducts = async () => {
    let searchQuery = query(collectionReference);
    const printfulSyncProductsResult = await getDocs(searchQuery);
    return preparePrintfulSyncProductsList(printfulSyncProductsResult);
}

const searchPrintfulSyncProducts = async (searchText, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    if (searchText) {
        searchQuery = query(collectionReference, where("textList", "array-contains", searchText));
    }

    searchQuery = query(searchQuery,
        orderBy('updatedAt', 'desc'));

    searchQuery = query(searchQuery, limit(perPage));

    const printfulSyncProductsResult = await getDocs(searchQuery);
    return preparePrintfulSyncProductsList(printfulSyncProductsResult);
}

const searchPrintfulSyncProductsWithSearchCriteria = async (searchCriteriaList, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    // console.log('searchPrintfulSyncProductsWithSearchCriteria', {searchCriteriaList});

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    /*if (searchCriteriaList.length === 0) {
        searchQuery = query(searchQuery, orderBy('updatedAt', 'desc'));
    }*/

    searchQuery = query(searchQuery, limit(perPage));

    const printfulSyncProductsResult = await getDocs(searchQuery);
    return preparePrintfulSyncProductsList(printfulSyncProductsResult);
}

const preparePrintfulSyncProductsList = (printfulSyncProductsResult) => {
    const printfulSyncProductsList = [];

    _.forEach(printfulSyncProductsResult.docs, printfulSyncProductsDoc => {
        printfulSyncProductsList.push(prepareSinglePrintfulSyncProducts(printfulSyncProductsDoc));
    });

    return printfulSyncProductsList;
}


const prepareSinglePrintfulSyncProducts = (printfulSyncProductsDoc) => {
    const printfulSyncProducts = printfulSyncProductsDoc.data();
    printfulSyncProducts.id = printfulSyncProductsDoc.id;
    return printfulSyncProducts;
}
